export enum Size {
  ExtraSmall = 'xs',
  Small = 's',
  Medium = 'm',
  Large = 'l',
  ExtraLarge = 'xl',
}
